module.exports = __webpack_public_path__ + "static/media/x_acc_logo.70c37b28.svg";